export const OSANO_SCRIPT_SRC =
	"https://cmp.osano.com/EvHV0kRj0s/820a9092-2ae0-4562-b723-c230167bec06/osano.js";

/** Stable mount point for the Osano CMP UI. Must match `data-osano-ui-target`. */
export const OSANO_UI_TARGET_ID = "osano-cmp-slot";
